import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function reportTokenReducer(
  state = initialState.reportToken,
  action
) {
  switch (action.type) {
    case types.GET_REPORT_TOKEN_SUCCESS:
      return action.reportToken;
    case types.GET_REPORT_TOKEN_REQUESTED:
    case types.GET_REPORT_TOKEN_FAILED:
      return null;
    default:
      return state;
  }
}
